// extracted by mini-css-extract-plugin
export default {"productImage":"InfoCard_productImage__FFCMA","cardContainer":"InfoCard_cardContainer__nXAsi","outOfStock":"InfoCard_outOfStock__Oien9"};